// extracted by mini-css-extract-plugin
export default {"container":"tBRe9g"};